export default "__VITE_ASSET__BmFEdFwp__$_?url__"